module.exports = __webpack_public_path__ + "static/ha5-e5f692227252c0389e875d3fd900c11e.jpg";